import { Send } from 'lucide-react';
import { useState } from 'react';

interface ChatInputProps {
  onSend?: (message: string) => void;
  placeholder?: string;
  quickReplies?: string[];
  onQuickReplyClick?: (reply: string) => void;
  disabled?: boolean;
}

export function ChatInput({
  onSend,
  placeholder: _placeholder = "Type your question about courses, trainers, fees, or schedules…",
  quickReplies: _quickReplies = [],
  onQuickReplyClick: _onQuickReplyClick,
  disabled = false,
}: ChatInputProps) {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim() && onSend && !disabled) {
      onSend(message);
      setMessage('');
    }
  };

  return (
    <div className="border-t border-[#E5E7EB] bg-white">
      {/* Quick Replies - removed per user request */}
      {/* Quick reply chips disabled */}

      {/* Input Area */}
      <form onSubmit={handleSubmit} className="px-4 pb-4 pt-2">
        <div className="flex items-end gap-2">
          <div className="flex-1 relative">
            <input
              type="text"
              id="chat-message-input"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={disabled ? "Reconnecting…" : "Type your question here"}
              autoComplete="off"
              disabled={disabled}
              className="w-full px-4 py-2.5 rounded-lg border border-[#E5E7EB] focus:outline-none focus:border-[#0B3D91] focus:ring-1 focus:ring-[#0B3D91] text-[15px] text-[#111827] placeholder:text-[#6B7280] bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
            />
          </div>
          <button
            type="submit"
            disabled={!message.trim() || disabled}
            className="bg-[#0B3D91] text-white rounded-lg px-4 py-2.5 hover:bg-[#0B3D91]/90 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
            aria-label="Send message"
          >
            <Send className="w-4 h-4" />
          </button>
        </div>
      </form>

      {/* Footer microcopy */}
      <div className="px-4 pb-3">
        <p className="text-[10px] text-[#9CA3AF] text-center">
          Powered by heu.ai
        </p>
      </div>
    </div>
  );
}